import * as React from 'react';

import { PropertySingleOffer } from '@shared-ui/lodging-property-offers';
import { RefTarget } from '@shared-ui/ref-context';

import { SharedUiWrapperProps, withSharedUiPropertyOffers } from './shared-ui-property-offers';
import { SingleOfferSearchForm } from 'components/infosite/single-offer-search';

const PropertySingleOfferWrapper: React.FC<SharedUiWrapperProps> = ({ data, inputs }) => (
  <div>
    <RefTarget name="Offers" tabIndex={0}>
      <PropertySingleOffer inputs={inputs} data={data}>
        <SingleOfferSearchForm />
      </PropertySingleOffer>
    </RefTarget>
  </div>
);

PropertySingleOfferWrapper.displayName = 'PropertySingleOfferWrapper';

export const SharedUiPropertySingleOfferWrapper = withSharedUiPropertyOffers(PropertySingleOfferWrapper);
